import React from "react";
import "./index.scss";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";
import { MORE_GRAPH_OPTIONS_VITAL } from "../../common/constant/common-constants";
import { handleOutsideClick } from "../../common/utils/CommonUtils";
import SnakeCanvas from "../Chart/SnakeCanvas";


const hiddenAxisConfig = () => ({
    yAxis: { labels: { show: false }, line: { show: false } },
    xAxis: { labels: { show: false }, line: { show: false } },
});


const MonitorChartDesktopView = ({
    secondvitalGraphName,
    setSecondVitalGraphName,
    secondMoreVitalECG,
    setSecondMoreVitalECG,
    dataRange,
    graphDrawerRef,
    canvasSize,
}) => {

    const handleSecondVitalECGSelect = (option) => {
        setSecondVitalGraphName(option);
        setSecondMoreVitalECG(false);
    };

    const handleSecondMoreVitalECG = (event) => {
        if (!secondMoreVitalECG) {
            handleOutsideClick(event, "vital-ecg-graph-2", setSecondMoreVitalECG);
        }
    };

    const onWindowSizeChange = (w, h) => {
        canvasSize.current = { width: w, height: h };
    };

    const onSymmetricalWindow = (key) => (min, max) => {
        if (min == null || max == null) return;
        const absMax = Math.max(Math.abs(min), Math.abs(max));
        const m = Math.ceil((absMax * 1.2) / 2) * 2 || 100;
        dataRange.current.current[key] = { min: -m, max: m };
    };

    const onPositiveWindow = (key) => (min, max) => {
        if (min == null || max == null) return;
        const absMax = Math.abs(max);
        const m = Math.ceil((absMax * 1.3) / 2) * 2 || 100;
        dataRange.current.current[key] = { min: 0, max: m };
    };

    const onCenteredWindow = (key) => (min, max) => {
        if (min == null || max == null) return;
        const center = (min + max) / 2;
        const halfRange = (max - min) / 2;
        const m = halfRange * 1.2 || 1;
        dataRange.current.current[key] = { min: center - m, max: center + m };
    };

    return (
        <div className="PM-Graphs">
            <div className="HR-graph">
                <div className="HR-top-bar">
                    <div className="HR-graph-num">II</div>
                </div>
                <div className="ecg-graph-1">
                    <SnakeCanvas
                        name="monitor-ecg-i"
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onSymmetricalWindow("ecgI")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.ecgI = d; }}
                        getDataRange={() => dataRange.current.current.ecgI}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="ecg-graph-wrap">
                <div
                    className="select-vital-ecg-container"
                    onClick={(event) => handleSecondMoreVitalECG(event)}
                >
                    <div className="selected-vital-ecg-name">
                        {secondvitalGraphName?.label}
                    </div>
                    {secondMoreVitalECG && (
                        <img className="arrow-img" src={whiteUpArrow} alt="up" />
                    )}
                    {!secondMoreVitalECG && (
                        <img className="arrow-img" src={whiteDownArrow} alt="down" />
                    )}
                </div>

                {secondMoreVitalECG && (
                    <div className="vital-graph-options" id="vital-ecg-graph-2">
                        {MORE_GRAPH_OPTIONS_VITAL.MONITOR.map((option) => (
                            <div
                                key={option.name}
                                className={
                                    option.name === secondvitalGraphName?.name
                                        ? "common-vital-ecg vital-ecg-active"
                                        : "common-vital-ecg"
                                }
                                onClick={() => handleSecondVitalECGSelect(option)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
                <div className="ecg-graph-2">
                    <SnakeCanvas
                        name={`monitor-ecg-ii-${secondvitalGraphName?.id}`}
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onSymmetricalWindow("ecgII")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.ecgII = d; }}
                        getDataRange={() => dataRange.current.current.ecgII}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="RR-graph">
                <div className="RR-top-bar">
                    <div className="RR-graph-num">Resp</div>
                </div>
                <div className="resp-graph">
                    <SnakeCanvas
                        name="monitor-resp"
                        nPointsPerWindow={3000}
                        headTailGapPx={50}
                        onWindowComplete={onPositiveWindow("resp")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.resp = d; }}
                        getDataRange={() => dataRange.current.current.resp}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>

            <div className="SPO2-graph">
                <div className="SPO2-top-bar">
                    <div className="SPO2-graph-num">Pleth</div>
                </div>
                <div className="pleth-graph">
                    <SnakeCanvas
                        name="monitor-pleth"
                        nPointsPerWindow={1600}
                        headTailGapPx={50}
                        onWindowComplete={onCenteredWindow("pleth")}
                        onWindowSizeChange={onWindowSizeChange}
                        onGraphDrawerChange={(d) => { graphDrawerRef.current.pleth = d; }}
                        getDataRange={() => dataRange.current.current.pleth}
                        getAxisConfig={hiddenAxisConfig}
                        leftPaddingPx={0}
                    />
                </div>
            </div>
        </div>
    );
};

export default MonitorChartDesktopView;
